import { put, takeLatest } from "redux-saga/effects";
import { ICycle, IQuestionnaireTemplate } from "src/common/types";
import { getCycle, getQuestionnaireTemplates } from "src/redux/actions";
import { mapError } from "../../../../../../helpers/error";
import { IGetCycleFormAction } from "../../types";

export function* getCycleForm({ payload: cycleId }: IGetCycleFormAction) {
  try {
    const cycle: ICycle | null = cycleId ? yield getCycle(cycleId) : null;

    if (cycle) {
      cycle.config =
        cycle.config === null
          ? {
              showCancelTalkButton: false,
              showFinalRatingButton: false,
              showReassignSupervisorButton: false,
              showReopenQuestionnaireButton: false,
              showReopenTalkButton: false,
              showReopenAnonymousDsvSummaryButton: false
            }
          : cycle.config;
    }

    const questionnaireTemplates: Promise<IQuestionnaireTemplate[]> = yield getQuestionnaireTemplates();

    yield put({
      payload: {
        cycle,
        questionnaireTemplates
      },
      type: "GET_CYCLE_FORM_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      payload: {
        e: mapError(e)
      },
      type: "GET_CYCLE_FORM_REJECTED"
    });
  }
}

export default function* cycleFormWatcher() {
  yield takeLatest("GET_CYCLE_FORM", getCycleForm);
}
